export const contentTypesWithTheHtmlEditor = ['cartoon', 'column', 'news', 'official-announcement', 'podcast', 'promotion', 'video'];

/** Special types normally filtered out from the contentTypes API. Can be included via includeContentTypes. */
export const EXTRA_CONTENT_TYPES = {
  RECIPE: 'recipe',
  DIGITAL_NEWSPAPER: 'digital-newspaper',
  SEO: 'seo',
};
